export const isMilestoneNameValid = ({ milestonesToCheck, milestoneName }) => (
  !milestonesToCheck.map((m) => m.name.toLowerCase()).includes(milestoneName.toLowerCase())
);

export const getAudits = (milestones) => (milestones ? milestones.filter((m) => m.isAudit) : []);
export const getMilestones = (milestones) => (milestones ? milestones.filter((m) => !m.isAudit) : []);

export const detailedDiffForDocumentIds = (attachedSignDocumentIdsSnapshot, attachedSignDocumentIdsForChanges) => {
  const added = attachedSignDocumentIdsForChanges.filter((id) => !attachedSignDocumentIdsSnapshot.includes(id));
  const deleted = attachedSignDocumentIdsSnapshot.filter((id) => !attachedSignDocumentIdsForChanges.includes(id));

  return {
    added,
    deleted,
  };
};
